import { VehicleList } from "./VehicleList";

export function TrailersList() {
  return <VehicleList resource="trailers" />;
}
